import { NutritionDeclaration } from '../../api';
import useGetDecimalSeparator from './use-get-decimal-separator';

export const splitNutritionValue = (text = '') => {
  const textStr = text.toString();
  const hasInequalityOperator = ['<', '>'].includes(textStr[0]);
  const numericString = hasInequalityOperator ? textStr.slice(1) : textStr;

  return {
    inequalityOperator: hasInequalityOperator ? textStr[0] : '',
    numericString,
    numericValue: Number(numericString.replace(',', '.')),
  };
};

export const getNumericValue = (text = '') => {
  const { numericValue } = splitNutritionValue(text);
  return numericValue;
};

export const isLower = (aValue?: string, bValue?: string) => {
  const { numericValue: aNumericValue } = splitNutritionValue(aValue);
  const { numericValue: bNumericValue } = splitNutritionValue(bValue);
  return aNumericValue < bNumericValue;
};

export const isLowerOrEqual = (aValue?: string, bValue?: string) => {
  const { numericValue: aNumericValue } = splitNutritionValue(aValue);
  const { numericValue: bNumericValue } = splitNutritionValue(bValue);
  return aNumericValue <= bNumericValue;
};

export const useGetNutritionDisplayValue = () => {
  const { getDecimalSeparator } = useGetDecimalSeparator();
  const { preferredDecimalSeparator } = getDecimalSeparator();

  const getNutritionDisplayValue = (
    nutritionDeclaration?: NutritionDeclaration
  ) => {
    return Object.fromEntries(
      Object.entries(nutritionDeclaration || {})
        .filter(
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          ([_, v]) => v !== null
        )
        .map(([key, value]) => {
          const normalizedValue =
            typeof value === 'string'
              ? value.replace('.', preferredDecimalSeparator)
              : value;
          return [key, normalizedValue];
        })
    );
  };

  return { getNutritionDisplayValue };
};
